import { UploadImage } from "./UploadImage/UploadImage";
import { RotateIcon } from "components/common/Icons/RotateIcon";
import { Slider } from "components/common/Slider/Slider";
import { useRotateSettings } from "./useRotateSettings";
import { Loader } from "components/common/Icons/Loader/Loader";
import { translateFunc } from "client/utils/translateFunc";
import { Translate } from "components/common/Translate/Translate";

export const RotateSettings = () => {
    const { handleStraightenChange, straighten, handleDirection, handleReset, handleSlideEnd, isRotating } =
        useRotateSettings();

    return (
        <div>
            <div className="hidden lg:block">
                <UploadImage />
            </div>
            <div className="flex flex-col gap-4">
                <div className="flex gap-4 my-8">
                    <div
                        className="w-full flex flex-col text-center gap-2"
                        onClick={() => handleDirection("clock-wise")}
                        data-testid={`clock-wise-rotate-button`}
                    >
                        <div>
                            <div
                                className={`cursor-pointer py-8 flex items-center justify-center border-slate-200 dark:border-darkSurface-400 border rounded-xl bg-white dark:bg-darkSurface-200 dark:hover:bg-darkSurface-100`}
                            >
                                {isRotating === "clock-wise" ? (
                                    <Loader className="stroke-[var(--dark-gray)]" width={34} height={34} />
                                ) : (
                                    <RotateIcon />
                                )}
                            </div>
                        </div>
                        <div className="capitalize">{translateFunc("common:clock-wise")}</div>
                    </div>
                    <div className="w-full flex flex-col text-center gap-2">
                        <div
                            onClick={() => handleDirection("reverse-clock-wise")}
                            data-testid={`counter-clock-wise-rotate-button`}
                        >
                            <div
                                className={`cursor-pointer py-8 flex items-center justify-center border border-slate-200 dark:border-darkSurface-400 rounded-xl flipped bg-white dark:bg-darkSurface-200 dark:hover:bg-darkSurface-100`}
                            >
                                {isRotating === "reverse-clock-wise" ? (
                                    <Loader className="stroke-[var(--dark-gray)]" width={34} height={34} />
                                ) : (
                                    <RotateIcon />
                                )}
                            </div>
                        </div>
                        <div className="capitalize">{translateFunc("common:counter-clock-wise")}</div>
                    </div>
                </div>

                <div className="flex flex-col gap-4">
                    <div className="capitalize">{translateFunc("common:straighten")}</div>
                    <div className="flex items-center dark:bg-darkSurface-200 gap-4 border border-irGray-400 dark:border-darkSurface-400 py-4 px-2 rounded-lg">
                        <div className="flex-grow">
                            <Slider
                                defaultValue={straighten}
                                value={straighten}
                                min={-45}
                                max={45}
                                handleChange={handleStraightenChange}
                                handleSlideEnd={handleSlideEnd}
                                testId={`straighten-slider`}
                            />
                        </div>
                        <div className="pt-1" data-testid={`straighten-value`}>
                            {`${straighten} °`}
                        </div>
                    </div>
                    <div className="text-sm text-irGray-500" data-testid={`straighten-label`}>
                        <Translate keyName="straighten-desc" />
                    </div>
                </div>

                <div
                    className="cursor-pointer dark:bg-darkSurface-200 dark:hover:bg-darkSurface-100 flex items-center justify-center border-irGray-400 border dark:border-darkSurface-400 rounded-lg my-6 text-center py-2 text-xl capitalize hover:bg-irGray-200"
                    onClick={handleReset}
                    data-testid={`reset-button`}
                >
                    <Translate keyName="common:reset" />
                </div>
            </div>
        </div>
    );
};
